import React from "react"
import { Common } from "lib/types"
import { Error404Page } from "views/404"

export const errorRoutes: Common.Views = [
  {
    element: <Error404Page />,
    path: "*"
  }
]
